module.exports = __webpack_public_path__ + "img/mtszys.e325648b.jpg";